import { fetchData } from './client';
import { AuthToken } from '@/contexts/AuthContext';

export type LoginRequest = {
  accountId: string;
  password: string;
};

export type LoginResponse = {
  // token?: string; // 旧形式
  accessToken: string; // 新形式
  tokenType: string;
  expiresIn: number;
};

export type RefreshTokenResponse = {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
};

export type LogoutResponse = {
  message: string;
};

export type ErrorResponse = {
  status: number;
  message: string;
  errors: any;
  data: any;
};

export const loginApi = async (credentials: LoginRequest): Promise<AuthToken> => {
  const response = await fetchData('auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include', // Cookieを受信するために必要
    body: JSON.stringify(credentials),
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response.json();
    throw new Error(errorData.message || 'ログインに失敗しました');
  }

  const result: LoginResponse = await response.json();

  return {
    token: result.accessToken,
    tokenType: result.tokenType,
    expiresIn: result.expiresIn,
  };
};

export const refreshTokenApi = async (): Promise<AuthToken> => {
  const response = await fetchData('auth/refresh', {
    method: 'POST',
    credentials: 'include', // Cookieを送信するために必要
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response.json();
    throw new Error(errorData.message || 'トークンのリフレッシュに失敗しました');
  }

  const result: RefreshTokenResponse = await response.json();

  return {
    token: result.accessToken,
    tokenType: result.tokenType,
    expiresIn: result.expiresIn,
  };
};

export const logoutApi = async (): Promise<void> => {
  const response = await fetchData('auth/logout', {
    method: 'POST',
    credentials: 'include', // Cookieを送信するために必要
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response.json();
    throw new Error(errorData.message || 'ログアウトに失敗しました');
  }
};

export type ChangePasswordRequest = {
  currentPassword: string;
  newPassword: string;
};

export type ChangePasswordResponse = {
  message: string;
  updatedAt: string;
};

export const changePasswordApi = async (
  data: ChangePasswordRequest
): Promise<ChangePasswordResponse> => {
  const response = await fetchData('users/me/change-password', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const errorData: ErrorResponse = await response.json();
    throw new Error(errorData.message || 'パスワードの変更に失敗しました');
  }

  const result: ChangePasswordResponse = await response.json();
  return result;
};
